import React from "react";
import {Box, Typography} from "@mui/material";
import dayjs from "dayjs";
import InfoIcon from "@assets/icons/infoIcon.tsx";
import {useSelector} from "react-redux";

const TicketCreated = () => {
    const {data} = useSelector((state: any) => state.chat.ticketCreate)
    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "row",
                marginTop: "2rem",
            }}
        >
            <Box
                sx={{
                    alignItems: "flex-end",
                    display: "flex",
                    flexDirection: "column",
                    width: "auto",
                    maxWidth: "80%", 
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "row",
                    }}
                >
                    <Box
                        sx={{
                            borderRadius: "50%",
                            bgcolor: "#fff",
                            width: "35px",
                            height: "35px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            mr: 1,
                        }}
                    >
                        <Typography
                            className="!text-[10px] md:!text-[14px]"
                            sx={{fontSize: "0.8rem"}}
                        >
                            OX
                        </Typography>
                    </Box>
                    <Box
                        sx={{
                            bgcolor: "#E6F4F7",
                            p: 2,
                            borderRadius: 1,
                        }}
                    >
                        <Typography className={'pb-2'}>Issue Raised</Typography>
                        <Box
                            sx={{
                                bgcolor: "#B0DEE5",
                                p: 2,
                                borderRadius: 1
                            }}
                        >
                            <div
                                className={'items-center justify-center flex gap-2.5 border-b pb-2 border-b-[#00697966]'}>
                                <InfoIcon/>
                                <Typography sx={{color: '#006979'}}>Specialist Contacted</Typography>
                            </div>
                            <div className={'px-2 pt-2 gap-1'}>
                                <Typography sx={{color: '#262626', fontSize: '0.75rem'}}>Specialist
                                    Name: OrganOx</Typography>
                                <Typography sx={{color: '#262626', fontSize: '0.75rem'}}>Ticket
                                    ID: {data.id}</Typography>
                                <Typography sx={{
                                    color: '#262626',
                                    fontSize: '0.75rem'
                                }}>{dayjs(data.createdAt).format('DD-MMM-YYYY | HH:mm')}</Typography>
                            </div>
                        </Box>
                    </Box>
                </Box>
            </Box>
        </Box>

    );
};
export default TicketCreated;
